import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import {
  CardData,
  LegendType,
  RowsData,
} from "api/interfaces/dashboardInterface.interface";
import ChartWrapper from "../graph/ChartWrapper";
import {
  GetDashboardDeviceCountResponse,
  statsInterval,
} from "api/interfaces/widgetInterface.interface";
import { useMemo, useState } from "react";
import { getDashboardDeviceCount } from "api/widgetAPI";
import {
  formatPercent,
  getRowsAndItems,
  getUniqueLabelRowsData,
} from "utils/StatsUtil";

export default function ClientDevice(props: CardData) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const [interval, setInterval] = useState<string>("1");
  const statsDevice = useQuery(
    ["statsDevice", selectedAccount.accountId, interval],
    () => {
      return getDashboardDeviceCount(Number(interval));
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );
  const { rows, items } = useMemo(() => {
    const data: GetDashboardDeviceCountResponse["result"] =
      statsDevice.data?.result ?? [];
    let rows: RowsData[] = getUniqueLabelRowsData(data, "os");
    return getRowsAndItems(rows, props.items);
  }, [props.items, statsDevice.data]);
  const legend: LegendType[] = useMemo(() => {
    let legend: LegendType[] = [...rows] as unknown as LegendType[];
    const total = legend.reduce((acc, curr) => acc + Number(curr.value), 0);
    return items.map((item, index) => ({
      label: item.label,
      value: formatPercent(Number(rows[index].value ?? 0), total),
      color: item.color,
    }));
  }, [items, rows]);
  return (
    <ChartWrapper
      rows={rows}
      items={items}
      unit="percent"
      isLoading={statsDevice.isLoading}
      onChangeInterval={setInterval}
      interval={interval as statsInterval}
      legend={legend}
    />
  );
}
